export const RESOURCES_HUB_VISIBLE_CARDS = 4;

export const RESOURCES_HUB_DEFAULT_SELECTION = ['site', 'sell'];
